import { debounce } from '@material-ui/core';
import { useCallback } from 'react';

const useDebounce = (fn, delay) =>
  useCallback(
    debounce((...args) => fn(...args), delay),
    [delay]
  );

export default useDebounce;
